import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=71ad4a6c&scoped=true&"
import script from "./Stories.vue?vue&type=script&lang=js&"
export * from "./Stories.vue?vue&type=script&lang=js&"
import style0 from "./Stories.vue?vue&type=style&index=0&id=71ad4a6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad4a6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
